'use client';

import { useEffect, useState } from "react";

export interface SalesforceProps {
    fetchUrl: string;
    campaignId: string;
    cookieName: string;
}

export default function Salesforce( { fetchUrl, campaignId, cookieName } : SalesforceProps) : React.JSX.Element {
    const [ anonymousId, setAnonymousId ] = useState<string>('');
    const [ experienceId, setExperienceId ] = useState<string>('');
    const [ abTestVariant, setAbTestVariant ] = useState<string>('');

    useEffect(() => {
        let anonymousId = '';
        let experienceId = '';
        let abTestVariant = '';

        const anonymousCookieKeyValue = document.cookie.split(';').find((cookieKeyValue) => {
            return cookieKeyValue.indexOf('SF_ANON_ID') >= 0;
        });

        if(anonymousCookieKeyValue) {
            anonymousId = anonymousCookieKeyValue.split('=')[1].trim();
        }

        const experienceCookieKeyValue = document.cookie.split(';').find((cookieKeyValue) => {
            return cookieKeyValue.indexOf(`SF_EXPID_${cookieName}`) >= 0;
        });

        if(experienceCookieKeyValue) {
            experienceId = experienceCookieKeyValue.split('=')[1].trim();
        }

        const abTestCookieKeyValue = document.cookie.split(';').find((cookieKeyValue) => {
            return cookieKeyValue.trim().startsWith(`${cookieName}=`);
        });

        if(abTestCookieKeyValue) {
            abTestVariant = abTestCookieKeyValue.split('=')[1].trim();
        }

        setAnonymousId(anonymousId);
        setExperienceId(experienceId);
        setAbTestVariant(abTestVariant);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!anonymousId || !experienceId || !abTestVariant || abTestVariant === 'EXCLD') return;

        const browserWindow = window as BrowserWindow;

        const sfImpressionEvent = async () => {
            const campaignFlagResponse = await fetch(
                fetchUrl,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        interaction: {
                            name: campaignId,
                        },
                        user: {
                            anonymousId: anonymousId,
                        },
                        campaignStats: [
                            {
                                experienceId: experienceId,
                                stat: 'Impression',
                                control: false,
                            },
                        ],
                        source: {
                            channel: 'Web',
                            url: location.href,
                            urlParams: Object.fromEntries(
                                new URLSearchParams(
                                    window.location.search
                                ).entries()
                            ),
                            urlReferrer: document.referrer,
                        },
                    }),
                }
            );

            const campaignFlagResponseJson = await campaignFlagResponse.json();
            const campaignResponse = campaignFlagResponseJson.campaignResponses[0];

            if (!campaignFlagResponse.ok) {
                return;
            }
            if (!campaignResponse?.payload?.flag) {
                return;
            }

            browserWindow.pushToAdobe(
                {
                    event: 'sfcampaign-dotcom-analytics-serverside-query',
                    salesForceInfoServerSide: {
                        [campaignId]: {
                            statType: 'Query',
                            isControl: campaignResponse?.payload?.isControl,
                            campaignId: campaignResponse?.campaignId,
                            campaignName: campaignResponse?.campaignName,
                            campaignType: campaignResponse?.campaignType,
                            experienceId: campaignResponse?.experienceId,
                            experienceName: campaignResponse?.experienceName,
                            payload: campaignResponse?.payload,
                            state: campaignResponse?.state,
                            templateNames: campaignResponse?.templateNames,
                            type: campaignResponse?.type,
                            userGroup: campaignResponse?.payload?.userGroup,
                        },
                    },
                }
            );

            browserWindow.pushToAdobe(
                {
                    event: 'sfcampaign-dotcom-analytics-serverside-impression',
                    salesForceInfoServerSide: {
                        [campaignId]: {
                            statType: 'Impression',
                            isControl: campaignResponse?.payload?.isControl,
                            campaignId: campaignResponse?.campaignId,
                            campaignName: campaignResponse?.campaignName,
                            campaignType: campaignResponse?.campaignType,
                            experienceId: campaignResponse?.experienceId,
                            experienceName: campaignResponse?.experienceName,
                            payload: campaignResponse?.payload,
                            state: campaignResponse?.state,
                            templateNames: campaignResponse?.templateNames,
                            type: campaignResponse?.type,
                            userGroup: campaignResponse?.payload?.userGroup,
                        },
                    },
                }
            );
        };

        sfImpressionEvent();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [anonymousId]);

    return <></>;
}